import { useState } from "react";
import { ButtonGroup, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { Href, WarningTop } from "../../../../Constants/Constants";

const AlignTopDemo = () => {
  const [open, setOpen] = useState(false);
  return (
    <ButtonGroup className="dropup">
      <Dropdown isOpen={open} toggle={() => setOpen(!open)} direction="up">
        <DropdownToggle caret color="warning" className="text-white">{WarningTop}</DropdownToggle>
        <DropdownMenu className="dropdown-block">
          <DropdownItem href={Href}>{"Be careful"}</DropdownItem>
          <DropdownItem href={Href}>{"Notifications"}</DropdownItem>
          <DropdownItem href={Href}>{"Beware"}</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  );
};
export default AlignTopDemo;
